import { useMemo } from "react";
import useSubscription from "hooks/useSubscription";

function useHyroxTier() {
  const subscription = useSubscription();

  return useMemo(() => {
    const planType = subscription?.planType;
    const isHyroxT0 = planType === "HyroxT0";
    const isHyroxT1 = planType === "HyroxT1";
    const isHyroxT2 = planType === "HyroxT2";
    const isHyrox = isHyroxT0 || isHyroxT1 || isHyroxT2;

    return { isHyrox, isHyroxT0, isHyroxT1, isHyroxT2 };
  }, [subscription]);
}

export default useHyroxTier;
